<!-- <p>maps-location-dialog works!</p> -->
<div
  [ngClass]="{
    'map-location-dialog-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'map-location-dialog-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="aumye-header">
    {{ data.header }}
    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="search-box">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="full-width"
    >
      <mat-label>Search location</mat-label>
      <input
        [disabled]="!isShowMap"
        matInput
        #searchInput
        type="text"
        placeholder="Enter address or place name"
        autocomplete="off"
        (keydown.enter)="performSearch()"
      />
      <button
        [disabled]="!isShowMap"
        mat-icon-button
        matSuffix
        (click)="performSearch()"
      >
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    <div class="current-location">
      <button
        [disabled]="!isShowMap"
        (click)="currentLocation()"
        mat-icon-button
        matTooltip="Use current location"
      >
        <mat-icon>location_on</mat-icon>
      </button>
    </div>
  </div>

  <google-map
    id="aumyemap"
    [height]="screenSize == ScreenType.Mobile ? '350px' : '450px'"
    [width]="'100%'"
    [center]="center"
    [zoom]="zoom"
    [mapId]="userId"
  >
    <map-advanced-marker
      [position]="markerPosition"
      [options]="markerOptions"
      (mapDragend)="onMarkerDragEnd($event)"
    ></map-advanced-marker>
  </google-map>

  <div class="address-display" *ngIf="address">
    <p><strong>Selected address:</strong> {{ address }}</p>
  </div>

  <div class="aumye-dialog-action">
    <button
      [disabled]="!coordinates"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="response"
    >
      Save Location
    </button>
  </div>
</div>
